module.exports = "<header class=\"header-area\">\n    <!-- <h1 class=\"text-center\">{{appTitle}}</h1> -->\n    <aa-navigation></aa-navigation>\n</header>\n"